import { Bloc } from "@kernel/frontend-react-app";
import { Stack } from "@kernel/utils";
import {
  defaultGlobalDialogState,
  DialogState,
  GlobalDialogState
} from "./GlobalDialogState";

export class GlobalDialogBloc extends Bloc<GlobalDialogState> {
  private constructor() {
    super(defaultGlobalDialogState);
  }

  public open({
    component,
    props,
    size,
    fullscreen
  }: Omit<DialogState, "open">) {
    const dialogs = this.state.dialogs
      .clone()
      .push({ open: true, component, props, size, fullscreen });
    this.changeState({ ...this.state, dialogs });
  }

  public close() {
    const dialogs = this.state.dialogs.clone();
    dialogs.pop();
    this.changeState({ ...this.state, dialogs });
  }

  public current() {
    return this.state.dialogs.head();
  }

  public closeAll() {
    this.changeState({ ...this.state, dialogs: new Stack<DialogState>() });
  }

  public static create() {
    return new GlobalDialogBloc();
  }
}
